export default __webpack_public_path__ + "static/mreavesmodot-4c7b3fdb32214f1890a5e816d65e1036.woff2";